import OverlayItem from './overlay/overlay-item'

class Overlay {
	constructor() {
		this.toShow = null
		
		if (document.body.classList.contains('show-drawer')) {
			this.toShow = document.querySelector(`[data-show-overlay]`)
		}
		
		this.addListeners()
	}
	
	addListeners() {
		let listeners = [].slice.call(document.querySelectorAll('[data-overlay]'));
		
		listeners.forEach((cta) => {
			let item = new OverlayItem(cta, this.toShow)
		})
	}
}

export default Overlay
